<template>
  <input
    ref="fromTextInput"
    v-model="favorite.title"
    @keydown.enter="handleEnter('enter')"
    @focusout="handleEnter('focusout')"
  />
</template>

<script>
import { ref, defineComponent, onMounted, watch, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import { useCommonStore } from "@/store/common";
import { useFavoritesStore } from "@/store/favorites.js";

export default defineComponent({
  name: "FavoriteInput",
  props: {
    favorite: {
      type: Object,
      required: false,
    },
    isDeleting: {
      // 추가
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const { favorite } = toRefs(props);

    const commonStore = useCommonStore();
    const favoritesStore = useFavoritesStore();
    const { changedFavoriteList, removeFavoriteList } = storeToRefs(favoritesStore);

    const fromTextInput = ref(null);

    onMounted(() => {
      fromTextInput.value.focus();
    });

    const handleEnter = async (name) => {
      // 삭제 중이면 저장 로직 실행 안함
      if (props.isDeleting) {
        return;
      }

      if (!favorite.value.isEdit) return;

      if (favorite.value.title !== "") {
        // 🔒 시스템 이름 사용 제한

        const normalize = (str) => str.replace(/\s+/g, "").toLowerCase(); // 모든 공백 제거 + 소문자화

        const restrictedNames = [
          normalize(t("label.favorite_rootFolder_my_favorite")),
          normalize(t("label.favorite_rootFolder_shared_favorite")),
          t("label.favorite_rootFolder_my_favorite"),
          t("label.favorite_rootFolder_shared_favorite"),
          "모든 제약사",
          "모든제약사",
          "myfavorites",
          "my favorites",
          "sharedfavorites",
          "shared favorites",
        ];

        if (restrictedNames.includes(favorite.value.title.trim().toLowerCase())) {
          commonStore.openAlertDialog({
            message: t("message.favorites_restricted_folder_name"),
            afterEvent: () => {
              favorite.value.title = "";
              favorite.value.isEdit = true;
            },
          });
          return;
        }

        const parent = favorite.value.parent;
        if (parent) {
          const type = favorite.value.isFolder ? "folder" : "favorite";
          // const sameFavorite = _.find(parent.children[type], { title: favorite.value.title });
          console.log("parent.children[type]", parent.children[type]);
          if (favorite.value.id === null) {
            const minId = Math.min(...changedFavoriteList.value.map((item) => item.id));
            favorite.value.id = minId - 1;
          }

          const sameFavorite = _.find(parent.children[type], (item) => {
            return item.title === favorite.value.title && item.id !== favorite.value.id;
          });
          console.log("sameFavorite", sameFavorite);
          if (sameFavorite && sameFavorite.id !== favorite.value.id) {
            if (favorite.value.isFolder) {
              commonStore.openAlertDialog({
                message: t("message.favorites_folder_with_the_same_name_already_exists"),
                afterEvent: () => {
                  _.remove(changedFavoriteList.value, favorite.value);

                  // 이름 초기화
                  favorite.value.title = "";
                  console.log("폴더 이름 초기화");
                },
                afterCancel: null,
              });
            } else {
              commonStore.openAlertDialog({
                message: t("message.favorites_with_the_same_name_already_exists"),
                afterEvent: () => {
                  _.remove(parent.children.favorite, sameFavorite);
                  _.remove(changedFavoriteList.value, sameFavorite);
                  removeFavoriteList.value.push(sameFavorite);

                  save();

                  emit("lockSave"); // 즐겨찾기창 취소(닫기)버튼 잠금

                  emit("triggerSave"); //저장 버튼 자동 실행
                },
                afterCancel: () => {
                  // 새로운 항목 삭제 (id === null인 경우 새로 생성된 것)
                  if (favorite.value.id === null || favorite.value.id <= -1) {
                    _.remove(parent.children.favorite, (item) => item === favorite.value);
                    _.remove(changedFavoriteList.value, (item) => item === favorite.value);
                  }

                  // 제목 초기화
                  favorite.value.title = "";
                  favorite.value.isEdit = false;
                },
              });
            }
            return;
          }
        }

        //새로생성된즐겨찾기 저장
        save();
      }
    };

    const save = () => {
      favorite.value.isEdit = false;
      if (changedFavoriteList.value.indexOf(favorite.value) === -1)
        changedFavoriteList.value.push(favorite.value);
    };

    return {
      fromTextInput,

      handleEnter,
    };
  },
});
</script>

<style scoped>
.folder-tree-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.folder-tree-item.selected {
  background-color: #efefef;
}

.material-symbols-outlined {
  font-size: 18px;
  margin-right: 8px;
  font-variation-settings: "wght" 300;
}
</style>
